import get from 'lodash/get'
import { ANALYTICS_EVENTS } from '../utils'

export const getFacilityProductsHandler = ({ events }) => {
  const {
    PRODUCT_VIEWED,
    PRODUCT_ADDED_TO_CART,
    CHECKOUT_STARTED,
    ORDER_COMPLETED,
    ORDER_PAYMENT_FAILED,
    PRODUCTS_SEARCHED
  } = ANALYTICS_EVENTS

  return {
    viewed: (product) => {
      events.track(PRODUCT_VIEWED, {
        product_id: product._id,
        product_name: product.name,
        price: product.latestPrice,
        stock_level: product.amountInStock,
        brand: get(product, 'additionalData.manufacturer'),
        category: product.productType
      })
    },

    addedToCart: ({ product, quantity }) => {
      events.track(PRODUCT_ADDED_TO_CART, {
        product_id: product._id,
        product_name: product.name,
        price: product.latestPrice,
        stock_level: product.amountInStock,
        brand: get(product, 'additionalData.manufacturer'),
        category: product.productType,
        quantity: quantity
      })
    },

    checkoutStarted: (data) => {
      const {orderValue, productCount, totalQuantity} = data
      events.track(CHECKOUT_STARTED, {
        order_value: orderValue,
        total_products: productCount,
        total_quantity: totalQuantity
      })
    },

    orderCompleted: (data) => {
      const {orderId, orderValue, productCount, totalQuantity} = data
      events.track(ORDER_COMPLETED, {
        order_value: orderValue,
        total_products: productCount,
        total_quantity: totalQuantity,
        order_id: orderId
      })
    },

    productsSearched: (data) => {
      const {
        filterTerm,
        selectedFilters,
        resultsCount
      } = data
      const filters = Object.values(selectedFilters).reduce((acc, filter) => {
        acc = acc.concat(filter.selected)
        return acc
      }, [])

      events.track(PRODUCTS_SEARCHED, {
        search_term: filterTerm,
        results_count: resultsCount,
        filters_used: filters
      })
    },

    // TODO: Find where to hook it to get expected results
    paymentFailed: ({orderValue, error}) => {
      events.track(ORDER_PAYMENT_FAILED, {
        order_value: orderValue,
        error: error
      })
    }
  }
}
